<template lang="pug">
  b-modal#addSubAccount(
  ref="addSubAccount"
  :title="$t('ui.combine.add_sub_account')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  size="lg"
  @ok="done"
  @show="reset"
  @shown="shown"
  @hide="closed")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.login_id')").mb-0
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ prefix }}
          DebounceInput(
            size="sm"
            ref="login_id"
            required
            alphaNum
            type="text"
            :dirty="$v.login_id.$dirty"
            :error="$v.login_id.$error"
            v-model.trim.lazy="$v.login_id.$model"
            :disabled="loading"
            :maxLength="$v.login_id.$params.maxLength.max"
          )
        ValidateResult(:value="$v.login_id" :name="$t('ui.login_id')")
      b-form-group(:label="$t('ui.password')").mb-0
        DebounceInput(
          size="sm"
          required
          type="password"
          :dirty="$v.password.$dirty"
          :error="$v.password.$error"
          v-model.trim.lazy="$v.password.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.password" :name="$t('ui.password')")
      b-form-group(:label="$t('ui.confirm_password')").mb-0
        DebounceInput(
          size="sm"
          required
          type="password"
          :dirty="$v.confirm_password.$dirty"
          :error="$v.confirm_password.$error"
          v-model.trim.lazy="$v.confirm_password.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.confirm_password" :name="$t('ui.confirm_password')", :name2="$t('ui.password')")
      div.row
        div.col-sm-12.col-md-12.col-lg-12
          b-form-group(:label="$t('ui.authority_option')").mb-3
            div.row
              div.col-sm-12.col-md-4.col-lg-4
                div.row.mb-3.animated.fadeIn
                  div.col
                    table.tablex(style="width: 100%;")
                      thead
                        tr
                          th.sticky-position.text-center(width="5%" style="z-index: 10;")
                            span
                              input(type="checkbox" @click="rowSelectAllAcc()" v-model="accAllSelected").checkbox
                          th.sticky-position(width="20%")
                            span(:title="$t('ui.account')") {{ $t("ui.account") }}
                      tbody.clusterize-content
                        tr(v-for="(item, index) in accList"
                          :class="{ 'selectedRow' : selectedRow(item) }")
                          td.actions.text-center
                            span
                              input(type="checkbox" v-model="item.checked").checkbox
                          td
                            span(:title="$t('ui.' + item.text)") {{ $t('ui.' + item.text) }}
              div.col-sm-12.col-md-4.col-lg-4
                div.row.mb-3.animated.fadeIn
                  div.col
                    table.tablex(style="width: 100%;")
                      thead
                        tr
                          th.sticky-position.text-center(width="5%" style="z-index: 10;")
                            span
                              input(type="checkbox" @click="rowSelectAllTix()" v-model="tixAllSelected").checkbox
                          th.sticky-position(width="20%")
                            span(:title='$tc("ui.tickets", 1)') {{ $tc("ui.tickets", 1) }}
                      tbody.clusterize-content
                        tr(v-for="(item, index) in tixList"
                          :class="{ 'selectedRow' : selectedRow(item) }")
                          td.actions.text-center
                            span
                              input(type="checkbox" v-model="item.checked").checkbox
                          td
                            span(:title="$t('ui.' + item.text)") {{ $t('ui.' + item.text) }}
              div.col-sm-12.col-md-4.col-lg-4
                div.row.mb-3.animated.fadeIn
                  div.col
                    table.tablex(style="width: 100%;")
                      thead
                        tr
                          th.sticky-position.text-center(width="5%" style="z-index: 10;")
                            span
                              input(type="checkbox" @click="rowSelectAllPromo()" v-model="promoAllSelected").checkbox
                          th.sticky-position(width="20%")
                            span(:title='$t("ui.promotion")') {{ $t("ui.promotion") }}
                      tbody.clusterize-content
                        tr(v-for="(item, index) in promoList"
                          :class="{ 'selectedRow' : selectedRow(item) }")
                          td.actions.text-center
                            span
                              input(type="checkbox" v-model="item.checked").checkbox
                          td
                            span(:title="$t('ui.' + item.text)") {{ $t('ui.' + item.text) }}
              div.col-sm-12.col-md-4.col-lg-4
                div.row.mb-3.animated.fadeIn
                  div.col
                    table.tablex(style="width: 100%;")
                      thead
                        tr
                          th.sticky-position.text-center(width="5%" style="z-index: 10;")
                            span
                              input(type="checkbox" @click="rowSelectAllBank()" v-model="bankAllSelected").checkbox
                          th.sticky-position(width="20%")
                            span(:title='$tc("ui.banks", 1)') {{ $tc("ui.banks", 1) }}
                      tbody.clusterize-content
                        tr(v-for="(item, index) in bankList"
                          :class="{ 'selectedRow' : selectedRow(item) }")
                          td.actions.text-center
                            span
                              input(type="checkbox" v-model="item.checked").checkbox
                          td
                            span(:title="$t('ui.' + item.text)") {{ $t('ui.' + item.text) }}
              div.col-sm-12.col-md-4.col-lg-4
                div.row.mb-3.animated.fadeIn
                  div.col
                    table.tablex(style="width: 100%;")
                      thead
                        tr
                          th.sticky-position.text-center(width="5%" style="z-index: 10;")
                            span
                              input(type="checkbox" @click="rowSelectAllSettings()" v-model="settingsAllSelected").checkbox
                          th.sticky-position(width="20%")
                            span(:title='$t("ui.settings")') {{ $t("ui.settings") }}
                      tbody.clusterize-content
                        tr(v-for="(item, index) in settingsList"
                          :class="{ 'selectedRow' : selectedRow(item) }")
                          td.actions.text-center
                            span
                              input(type="checkbox" v-model="item.checked").checkbox
                          td
                            span(:title="$t('ui.' + item.text)") {{ $t('ui.' + item.text) }}
              div.col-sm-12.col-md-4.col-lg-4
                div.row.mb-3.animated.fadeIn
                  div.col
                    table.tablex(style="width: 100%;")
                      tbody.clusterize-content
                        tr(v-for="(item, index) in vipList"
                          :class="{ 'selectedRow' : selectedRow(item) }")
                          td.actions.text-center(width="5%" style="z-index: 10;")
                            span
                              input(type="checkbox" v-model="item.checked").checkbox
                          td(width="20%")
                            span(:title="$t('ui.' + item.text)") {{ $t('ui.' + item.text) }}
                div.row.mb-3.animated.fadeIn
                  div.col
                    table.tablex(style="width: 100%;")
                      tbody.clusterize-content
                        tr(v-for="(item, index) in dashboardList"
                          :class="{ 'selectedRow' : selectedRow(item) }")
                          td.actions.text-center(width="5%" style="z-index: 10;")
                            span
                              input(type="checkbox" v-model="item.checked").checkbox
                          td(width="20%")
                            span(:title="$t('ui.' + item.text)") {{ $t('ui.' + item.text) }}
                div.row.mb-3.animated.fadeIn
                  div.col
                    table.tablex(style="width: 100%;")
                      tbody.clusterize-content
                        tr(v-for="(item, index) in cmsList"
                          :class="{ 'selectedRow' : selectedRow(item) }")
                          td.actions.text-center(width="5%" style="z-index: 10;")
                            span
                              input(type="checkbox" v-model="item.checked").checkbox
                          td(width="20%")
                            span(:title="$t('ui.' + item.text)") {{ $t('ui.' + item.text) }}
                div.row.mb-3.animated.fadeIn
                  div.col
                    table.tablex(style="width: 100%;")
                      tbody.clusterize-content
                        tr(v-for="(item, index) in affList"
                          :class="{ 'selectedRow' : selectedRow(item) }")
                          td.actions.text-center(width="5%" style="z-index: 10;")
                            span
                              input(type="checkbox" v-model="item.checked").checkbox
                          td(width="20%")
                            span(:title="$t('ui.' + item.text)") {{ $t('ui.' + item.text) }}
                div.row.mb-3.animated.fadeIn
                  div.col
                    table.tablex(style="width: 100%;")
                      tbody.clusterize-content
                        tr(v-for="(item, index) in reviewList"
                          :class="{ 'selectedRow' : selectedRow(item) }")
                          td.actions.text-center(width="5%" style="z-index: 10;")
                            span
                              input(type="checkbox" v-model="item.checked").checkbox
                          td(width="20%")
                            span(:title="$tc('ui.' + item.text, 1)") {{ $tc('ui.' + item.text, 1) }}
              div.col-sm-12.col-md-4.col-lg-4
                div.row.mb-3.animated.fadeIn
                  div.col
                    table.tablex(style="width: 100%;")
                      thead
                        tr
                          th.sticky-position.text-center(width="5%" style="z-index: 10;")
                            span
                              input(type="checkbox" @click="rowSelectAllReport()" v-model="reportAllSelected").checkbox
                          th.sticky-position(width="20%")
                            span(:title='$t("ui.report")') {{ $t("ui.report") }}
                      tbody.clusterize-content
                        tr(v-for="(item, index) in reportList"
                          :class="{ 'selectedRow' : selectedRow(item) }")
                          td.actions.text-center
                            span
                              input(type="checkbox" v-model="item.checked").checkbox
                          td
                            span(:title="$t('ui.' + item.text)") {{ $t('ui.' + item.text) }}
              div.col-sm-12.col-md-4.col-lg-4
                div.row.mb-3.animated.fadeIn
                  div.col
                    table.tablex(style="width: 100%;")
                      thead
                        tr
                          th.sticky-position.text-center(width="5%" style="z-index: 10;")
                            span
                              input(type="checkbox" @click="rowSelectAllLog()" v-model="logAllSelected").checkbox
                          th.sticky-position(width="20%")
                            span(:title='$t("ui.log")') {{ $t("ui.log") }}
                      tbody.clusterize-content
                        tr(v-for="(item, index) in logList"
                          :class="{ 'selectedRow' : selectedRow(item) }")
                          td.actions.text-center
                            span
                              input(type="checkbox" v-model="item.checked").checkbox
                          td
                            span(:title="$t('ui.' + item.text)") {{ $t('ui.' + item.text) }}
                div.row.mb-3.animated.fadeIn
                  div.col
                    table.tablex(style="width: 100%;")
                      thead
                        tr
                          th.sticky-position.text-center(width="5%" style="z-index: 10;")
                            span
                              input(type="checkbox" @click="rowSelectAllReportPromo()" v-model="reportPromoAllSelected").checkbox
                          th.sticky-position(width="20%")
                            span(:title='$t("ui.report_promotion")') {{ $t("ui.report_promotion") }}
                      tbody.clusterize-content
                        tr(v-for="(item, index) in reportPromoList"
                          :class="{ 'selectedRow' : selectedRow(item) }")
                          td.actions.text-center
                            span
                              input(type="checkbox" v-model="item.checked").checkbox
                          td
                            span(:title="$t('ui.' + item.text)") {{ $t('ui.' + item.text) }}
              div.col-sm-12.col-md-4.col-lg-4
                div.row.mb-3.animated.fadeIn
                  div.col
                    table.tablex(style="width: 100%;")
                      thead
                        tr
                          th.sticky-position.text-center(width="5%" style="z-index: 10;")
                            span
                              input(type="checkbox" @click="rowSelectAllAction()" v-model="actionAllSelected").checkbox
                          th.sticky-position(width="20%")
                            span(:title='$t("ui.action")') {{ $t("ui.action") }}
                      tbody.clusterize-content
                        tr(v-for="(item, index) in actionList"
                          :class="{ 'selectedRow' : selectedRow(item) }")
                          td.actions.text-center
                            span
                              input(type="checkbox" v-model="item.checked").checkbox
                          td
                            span(:title="$t('ui.' + item.text)") {{ $t('ui.' + item.text) }}
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import authority from "@/authority";
const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      login_id: "",
      password: "",
      confirm_password: "",
      authority_option: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      authority_list: authority.list,
      accLas: false,
      tixLas: false,
      bankLas: false,
      promoLas: false,
      settingsLas: false,
      logLas: false,
      reportLas: false,
      reportPromoLas: false,
      actionLas: false,
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    isAdmin() {
      return this.$store.getters.accountId == config.superUser;
    },
    authorityList() {
      let list = this.isAdmin == true ? config.adminAccessOptions : config.operatorAccessOptions;

      let result = [];
      list.forEach( value => {
        result.push({value:value, text:this.$t("ui.authority." + value)});
      })
      return result;
    },
    prefix() {
      if (this.$store.getters.account[0].account_id)
        return this.$store.getters.account[0].account_id + '@';

      return '';
    },
    accList() {
      return this.authority_list.filter(d => { return d.category == "account" && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
    },
    tixList() {
      return this.authority_list.filter(d => { return d.category == "ticket" && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
    },
    bankList() {
      return this.authority_list.filter(d => { return d.category == "bank" && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
    },
    promoList() {
      return this.authority_list.filter(d => { return d.category == "promotion" && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
    },
    settingsList() {
      return this.authority_list.filter(d => { return d.category == "settings" && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
    },
    vipList() {
      return this.authority_list.filter(d => { return d.category == "vip" && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
    },
    dashboardList() {
      return this.authority_list.filter(d => { return d.category == "dashboard" && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
    },
    cmsList() {
      return this.authority_list.filter(d => { return d.category == "cms" && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
    },
    affList() {
      return this.authority_list.filter(d => { return d.category == "affiliate" && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
    },
    logList() {
      return this.authority_list.filter(d => { return d.category == "log" && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
    },
    reportList() {
      return this.authority_list.filter(d => { return d.category == "report" && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
    },
    reportPromoList() {
      return this.authority_list.filter(d => { return d.category == "reportpromotion" && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
    },
    actionList() {
      return this.authority_list.filter(d => { return d.category == "action" && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
    },
    reviewList() {
      return this.authority_list.filter(d => { return d.category == "review" && (d.type == "both" || d.type == (this.isAdmin == true ? "admin" : "opr")) });
    },
    accAllSelected:
    {
      get() {
        if (this.accList.length == 0)
          return false;
        else if (this.accList.filter(item => { return item.checked == true; }).length == this.accList.length)
          return true;
        else if (this.accList.filter(item => { return item.checked == true; }).length != this.accList.length)
          return false;
        else if (this.accLas)
          return this.accLas;
        else
          return false;
      },
      set(value) {
        this.accLas = value;
      }
    },
    tixAllSelected:
    {
      get() {
        if (this.tixList.length == 0)
          return false;
        else if (this.tixList.filter(item => { return item.checked == true; }).length == this.tixList.length)
          return true;
        else if (this.tixList.filter(item => { return item.checked == true; }).length != this.tixList.length)
          return false;
        else if (this.tixLas)
          return this.tixLas;
        else
          return false;
      },
      set(value) {
        this.tixLas = value;
      }
    },
    bankAllSelected:
    {
      get() {
        if (this.bankList.length == 0)
          return false;
        else if (this.bankList.filter(item => { return item.checked == true; }).length == this.bankList.length)
          return true;
        else if (this.bankList.filter(item => { return item.checked == true; }).length != this.bankList.length)
          return false;
        else if (this.bankLas)
          return this.bankLas;
        else
          return false;
      },
      set(value) {
        this.bankLas = value;
      }
    },
    promoAllSelected:
    {
      get() {
        if (this.promoList.length == 0)
          return false;
        else if (this.promoList.filter(item => { return item.checked == true; }).length == this.promoList.length)
          return true;
        else if (this.promoList.filter(item => { return item.checked == true; }).length != this.promoList.length)
          return false;
        else if (this.promoLas)
          return this.promoLas;
        else
          return false;
      },
      set(value) {
        this.promoLas = value;
      }
    },
    settingsAllSelected:
    {
      get() {
        if (this.settingsList.length == 0)
          return false;
        else if (this.settingsList.filter(item => { return item.checked == true; }).length == this.settingsList.length)
          return true;
        else if (this.settingsList.filter(item => { return item.checked == true; }).length != this.settingsList.length)
          return false;
        else if (this.settingsLas)
          return this.settingsLas;
        else
          return false;
      },
      set(value) {
        this.settingsLas = value;
      }
    },
    logAllSelected:
    {
      get() {
        if (this.logList.length == 0)
          return false;
        else if (this.logList.filter(item => { return item.checked == true; }).length == this.logList.length)
          return true;
        else if (this.logList.filter(item => { return item.checked == true; }).length != this.logList.length)
          return false;
        else if (this.logLas)
          return this.logLas;
        else
          return false;
      },
      set(value) {
        this.logLas = value;
      }
    },
    reportAllSelected:
    {
      get() {
        if (this.reportList.length == 0)
          return false;
        else if (this.reportList.filter(item => { return item.checked == true; }).length == this.reportList.length)
          return true;
        else if (this.reportList.filter(item => { return item.checked == true; }).length != this.reportList.length)
          return false;
        else if (this.reportLas)
          return this.reportLas;
        else
          return false;
      },
      set(value) {
        this.reportLas = value;
      }
    },
    reportPromoAllSelected:
    {
      get() {
        if (this.reportPromoList.length == 0)
          return false;
        else if (this.reportPromoList.filter(item => { return item.checked == true; }).length == this.reportPromoList.length)
          return true;
        else if (this.reportPromoList.filter(item => { return item.checked == true; }).length != this.reportPromoList.length)
          return false;
        else if (this.reportPromoLas)
          return this.reportPromoLas;
        else
          return false;
      },
      set(value) {
        this.reportPromoLas = value;
      }
    },
    actionAllSelected:
    {
      get() {
        if (this.actionList.length == 0)
          return false;
        else if (this.actionList.filter(item => { return item.checked == true; }).length == this.actionList.length)
          return true;
        else if (this.actionList.filter(item => { return item.checked == true; }).length != this.actionList.length)
          return false;
        else if (this.actionLas)
          return this.actionLas;
        else
          return false;
      },
      set(value) {
        this.actionLas = value;
      }
    },
  },
  validations: {
    login_id: {
      required,
      alphaNum,
      minLength: minLength(2),
      maxLength: maxLength(20)
    },
    password: {
      required,
      containAlphaNum,
      minLength: minLength(6),
      maxLength: maxLength(50)
    },
    confirm_password: {
      required,
      sameAs: sameAs("password")
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    selectedRow: function(info) {
      if (info.checked)
        return true;

      return false;
    },
    rowSelectAllAcc: function(info, ev) {
      setTimeout(() => {
        if (this.accLas) {
          this.accList.map(function(x) {
            x.checked = true;
            return x;
          });
        } else {
          this.accList.map(function(x) {
            x.checked = false;
            return x;
          });
        }
      }, 10);
    },
    rowSelectAllTix: function(info, ev) {
      setTimeout(() => {
        if (this.tixLas) {
          this.tixList.map(function(x) {
            x.checked = true;
            return x;
          });
        } else {
          this.tixList.map(function(x) {
            x.checked = false;
            return x;
          });
        }
      }, 10);
    },
    rowSelectAllBank: function(info, ev) {
      setTimeout(() => {
        if (this.bankLas) {
          this.bankList.map(function(x) {
            x.checked = true;
            return x;
          });
        } else {
          this.bankList.map(function(x) {
            x.checked = false;
            return x;
          });
        }
      }, 10);
    },
    rowSelectAllPromo: function(info, ev) {
      setTimeout(() => {
        if (this.promoLas) {
          this.promoList.map(function(x) {
            x.checked = true;
            return x;
          });
        } else {
          this.promoList.map(function(x) {
            x.checked = false;
            return x;
          });
        }
      }, 10);
    },
    rowSelectAllSettings: function(info, ev) {
      setTimeout(() => {
        if (this.settingsLas) {
          this.settingsList.map(function(x) {
            x.checked = true;
            return x;
          });
        } else {
          this.settingsList.map(function(x) {
            x.checked = false;
            return x;
          });
        }
      }, 10);
    },
    rowSelectAllLog: function(info, ev) {
      setTimeout(() => {
        if (this.logLas) {
          this.logList.map(function(x) {
            x.checked = true;
            return x;
          });
        } else {
          this.logList.map(function(x) {
            x.checked = false;
            return x;
          });
        }
      }, 10);
    },
    rowSelectAllReport: function(info, ev) {
      setTimeout(() => {
        if (this.reportLas) {
          this.reportList.map(function(x) {
            x.checked = true;
            return x;
          });
        } else {
          this.reportList.map(function(x) {
            x.checked = false;
            return x;
          });
        }
      }, 10);
    },
    rowSelectAllReportPromo: function(info, ev) {
      setTimeout(() => {
        if (this.reportPromoLas) {
          this.reportPromoList.map(function(x) {
            x.checked = true;
            return x;
          });
        } else {
          this.reportPromoList.map(function(x) {
            x.checked = false;
            return x;
          });
        }
      }, 10);
    },
    rowSelectAllAction: function(info, ev) {
      setTimeout(() => {
        if (this.actionLas) {
          this.actionList.map(function(x) {
            x.checked = true;
            return x;
          });
        } else {
          this.actionList.map(function(x) {
            x.checked = false;
            return x;
          });
        }
      }, 10);
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.accountSubAddUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          sub_login_id: this.prefix + this.login_id,
          password: this.password,
          authority_option: this.authority_list.filter(item => { return item.checked == true}).map(i => i.value).join(','),
          audit_by: this.$store.getters.loginId,
          account_id: this.$store.getters.accountId
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.addSubAccount.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_sub_account", this.feedback.status);
                  this.$refs.addSubAccount.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.login_id = "";
      this.password = "";
      this.confirm_password = "";
      this.authority_option = [];
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.login_id.$el.focus();
    },
    closed: function() {
      this.login_id = "";
      this.authority_list.map(function(x) {
        x.checked = false;
        return x;
      });
    }
  }
};
</script>
